<template src="./PatientAttendance.html"></template>
<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
import mixins from "@/Mixins.js";
export default {
  mixins: [mixins],
  name: "patient-attendance",
  components: { WholeMultiselect },
  props: ["medicalRecordId", "noEditable"],
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      showEndButtons: true,
      token: "",
      printButtonClicked: "",
      type: "margin",
      popupPrintMedicalRecord: false,
      notPrint: true,
      someMedicines: "",
      colorx: "#ffae42",
      popupCompletedAndPrintMedicalRecord: false,
      notPrescription: false,
      notExams: false,
      exams: [],
      options: [
        { text: "Pago", value: true },
        { text: "Gratuito", value: false }
      ],
      examsAdd: [{ id: "", description: "" }],
      commonDrugAdd: [],
      commonDrugs: [{"active":true,"product":"_","activePrinciple":"_","presentation":"_","laboratory":"_","usage":null,"id":0}],
      charsCommonDrugs: [],
      psychotropicControlledDrugsAdd: [],
      controlledDrugs: [{"active":true,"product":"_","activePrinciple":"_","presentation":"_","laboratory":"_","usage":null,"id":0}],
      charsControlledDrugs: [],
      prescriptionDrugs: [{"active":true,"product":"_","activePrinciple":"_","presentation":"_","laboratory":"_","usage":null,"id":0}],
      prescriptionDrugsAdd: [],
      charsPrescriptionDrugs: [],
      diagnosticHypothesis: [],
      diagnosticHypothesisAdd: [{ id: "", description: "" }],
      charsDiagnosticHypothesis: [],
      returnPatient: false,
      dischargedPatient: false,
      paid: null,
      patientHealthData: [],
      registrationData: [],
      status: [],
      conduct: [],
      attendance: [],
      someExams: "",
      medicalRecommendations: "",
      appointment: [],
      patientReturn: false,
      patientDischarge: false,
      clickedSaveChanges: false,
      hasEnded: false,
      inputDayNextSteps: null,
      mainComplaint: "",
      consultationDuration: "",
      clinicalExam: "",
      pageCommon: 0,
      totalPagesCommon: 0,
      searchCommon: "",
      commonDrugsIsLoading: false,
      pagePrescription: 0,
      totalPagesPrescription: 0,
      searchPrescription: "",
      prescriptionDrugsIsLoading: false,
      pageControlled: 0,
      totalPagesControlled: 0,
      searchControlled: "",
      controlledDrugsIsLoading: false,
      isLoadingCid: false,
      timeout: null,
      newDiagnostic: "",
      currentx: 0,
      numPages: 0,
      pagination: false,
      doFinalize: false,
    };
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  mounted() {
    const vm = this;
    vm.getDiagnosticHypothesis("");
    vm.getMedicinesCommon();
    vm.getMedicinesPrescription();
    vm.getMedicinesControlled();
    vm.addPrescriptionDrugs();
    vm.getExams();
    vm.addCommonDrug();
    vm.addControlledDrugs();
    vm.getPatientHealthData();
    vm.getRegistrationData();
    vm.getMedicalRecordStatus();
    vm.getConduct();
    vm.getAttendance();
    vm.calculateIMC();
    vm.getToken();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  computed: {
    showPDFMessage() {
      const vm = this;
      return vm.popupPrintMedicalRecord && (vm.commonDrugAddNotEmpty() || vm.prescriptionDrugsAddNotEmpty()
       || vm.examNotEmpty() || vm.recomendationNotEmpty())
    },
    showAllOption() {
      const vm = this;
      return vm.popupPrintMedicalRecord && vm.examNotEmpty() && vm.commonDrugAddNotEmpty()
       && vm.prescriptionDrugsAddNotEmpty() && vm.recomendationNotEmpty();
    },
    showRecomendationOption() {
      const vm = this;
      return vm.popupPrintMedicalRecord && vm.recomendationNotEmpty();
    },
    showCommonDrugOption: function() {
      const vm = this;
      return vm.popupPrintMedicalRecord &&  vm.commonDrugAddNotEmpty();
    },
    showPrescriptionOption() {
      const vm = this;
      return vm.popupPrintMedicalRecord && vm.prescriptionDrugsAddNotEmpty();
    },
    showExamOption() {
      const vm = this;
      return vm.popupPrintMedicalRecord && vm.examNotEmpty();
    },
    getOptions() {
      const vm = this;
      return vm.diagnosticHypothesisAdd;
    },
    conductDto() {
      const vm = this;
      return {
        canEdit: true,
        clinic: vm.conduct.clinic,
        commonPrescriptionDrug:
          Object.keys(vm.commonDrugAdd[0]).length === 0
            ? [null]
            : vm.commonDrugAdd.filter(obj => !vm.testNullUndefinedEmpty(obj.drug)),
        daysToReturn: parseInt(vm.inputDayNextSteps, 10),
        doctor: vm.conduct.doctor,
        drugControlledPsychotropic:
          Object.keys(vm.psychotropicControlledDrugsAdd[0]).length === 0
            ? [null]
            : vm.psychotropicControlledDrugsAdd.filter(obj => !vm.testNullUndefinedEmpty(obj.drug)),
        drugControlledRevenue:
          Object.keys(vm.prescriptionDrugsAdd[0]).length === 0
            ? [null]
            : vm.prescriptionDrugsAdd.filter(obj => !vm.testNullUndefinedEmpty(obj.drug)),
        exams: vm.examsAdd[0].id === "" ? [null] : vm.examsAdd,
        generalAttestations: null,
        generalExams: null,
        generalReports: null,
        generalVaccines: null,
        medicalRecommendations: vm.medicalRecommendations,
        nextStep:
          vm.appointment.nextStep !== null &&
          vm.appointment.nextStep !== undefined
            ? vm.appointment.nextStep
            : null,
        nextStepsDoctor: null,
        numDaysReturn: parseInt(vm.inputDayNextSteps, 10),
        paid: vm.paid,
        patientId: vm.attendance.patientId,
        patientName: vm.attendance.patientName,
        payStatus: vm.paid == false ? "gratuito" : "pago",
        proxPasso:
          vm.appointment.nextStep !== null &&
          vm.appointment.nextStep !== undefined
            ? vm.appointment.nextStep.type == "DISCHARGE"
              ? "alta"
              : "retorno"
            : null,

        someExams: vm.someExams,
        someMedicines: vm.someMedicines
      };
    }
  },
  watch: {
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
    commonDrugAdd: {
      handler: function() {
        const vm = this;
        let position= 0;
        for (var i in vm.commonDrugAdd) {
          position = position + 1;
          if(vm.testNullUndefinedEmpty(vm.commonDrugAdd[i].drug) && (position !== vm.commonDrugAdd.length)) {
            vm.commonDrugAdd.splice(i, 1);
          }
        }
      },
      deep: true
    },
    prescriptionDrugsAdd: {
      handler: function() {
        const vm = this;
        let position= 0;
        for (var i in vm.prescriptionDrugsAdd) {
          position = position + 1;
          if(vm.testNullUndefinedEmpty(vm.prescriptionDrugsAdd[i].drug) && (position !== vm.prescriptionDrugsAdd.length)) {
            vm.prescriptionDrugsAdd.splice(i, 1);
          }
        }
      },
      deep: true
    },
    psychotropicControlledDrugsAdd: {
      handler: function() {
        const vm = this;
        let position= 0;
        for (var i in vm.psychotropicControlledDrugsAdd) {
          position = position + 1;
          if(vm.testNullUndefinedEmpty(vm.psychotropicControlledDrugsAdd[i].drug) && (position !== vm.psychotropicControlledDrugsAdd.length)) {
            vm.psychotropicControlledDrugsAdd.splice(i, 1);
          }
        }
      },
      deep: true
    }
  },
  methods: {
    handleResize() {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      if (vm.window.width < 690) {
        vm.showEndButtons = false;
      } else {
        vm.showEndButtons = true;
      }
    },
    disableCommonDrugDescription(index) {
      const vm = this;
      if(!vm.testNullUndefinedEmpty(vm.commonDrugAdd[index])) {
        let isEmpty = vm.testNullUndefinedEmpty(vm.commonDrugAdd[index].drug);
        if(isEmpty) vm.commonDrugAdd[index].description = "";
        return isEmpty;
      }
      return true;
    },
    disablePrescriptionDescription(index) {
      const vm = this;
      if(!vm.testNullUndefinedEmpty(vm.prescriptionDrugsAdd[index])) {
        let isEmpty = vm.testNullUndefinedEmpty(vm.prescriptionDrugsAdd[index].drug);
        if(isEmpty) vm.prescriptionDrugsAdd[index].description = "";
        return isEmpty;
      }
      return true;
    },
    disablePsychotropicControlledDrugsnDescription(index) {
      const vm = this;
      if(!vm.testNullUndefinedEmpty(vm.psychotropicControlledDrugsAdd[index])) {
        let isEmpty = vm.testNullUndefinedEmpty(vm.psychotropicControlledDrugsAdd[index].drug);
        if(isEmpty) vm.psychotropicControlledDrugsAdd[index].description = "";
        return isEmpty;
      }
      return true;
    },
    printMedicalRecord() {
      const vm = this;
      vm.imprimir ++;
      vm.popupPrintMedicalRecord = true;
    },
    async validateFields() {
      const vm = this;
      let isInvalid = false;
      if (vm.patientDischarge === false && vm.patientReturn === false) {
        vm.$vs.notify({
          title: "Atenção",
          time: 2000,
          position: "top-right",
          text: "Selecione o próximo passo do paciente.",
          color: "warning"
        });
        isInvalid = true;
      }
      if (vm.patientReturn === true && vm.inputDayNextSteps === null) {
        vm.$vs.notify({
          title: "Atenção",
          time: 2000,
          position: "top-right",
          text: "Digite a quantidade de dias para o retorno do paciente.",
          color: "warning"
        });
        isInvalid = true;
      }
      if (vm.patientReturn === true && vm.inputDayNextSteps == 0) {
        vm.$vs.notify({
          title: "Atenção",
          time: 2000,
          position: "top-right",
          text:
            'A quantidade de dias para o retorno não pode ser "0", aumente e tente novamente.',
          color: "warning"
        });
        isInvalid = true;
      }
      if (vm.paid == null) {
        vm.$vs.notify({
          title: "Atenção",
          time: 2000,
          position: "top-right",
          text:
            "Selecione uma das opções referente ao atendimento (Pago ou Gratuito).",
          color: "warning"
        });
        isInvalid = true;
      }
      if (vm.patientDischarge === false && vm.inputDayNextSteps > 0) {
        vm.selectNextStep(vm.inputDayNextSteps);
      } else {
        if (vm.patientDischarge === true) {
          vm.selectNextStep(0);
        }
      }

      return !isInvalid
    },
    async saveChanges() {
      const vm = this;
      vm.$vs.loading()
      vm.canEdit = true;

      const dataIsValid = await vm.validateFields()

      if (dataIsValid) {
        try {
          await Promise.all([vm.savePatientAttendance(), vm.updateConduct()])

          vm.$swal({
            title: "Sucesso!",
            text: "Dados salvos com sucesso",
            icon: "success"
          });
          vm.clickedSaveChanges = true;
        } catch (error) {
          vm.$swal({
            title: "Erro!",
            text: "Ocorreu um erro ao tentar salvar o prontuário",
            icon: "error"
          });
        }
      }
      vm.$vs.loading.close()
    },
    async endService() {
      const vm = this;
      vm.$vs.loading()

      vm.canEdit = vm.attendance.canEdit;

      const dataIsValid = await vm.validateFields()

      if (dataIsValid) {
        try {
          vm.doFinalize = true;
          await vm.savePatientAttendance()
          await vm.saveConduct()
          
          vm.$swal({
            title: "Sucesso!",
            text: "Consulta finalizada com sucesso",
            icon: "success"
          });
          vm.hasEnded = true;
        } catch (error) {
          vm.$swal({
            title: "Erro",
            text: "Ocorreu um erro ao finalizar a consulta",
            icon: "error"
          });
        }
      }
      vm.doFinalize = false;
      vm.$vs.loading.close()
    },
    async savePatientAttendance() {
      const vm = this;
      let diagnosis = {
        doFinalize: vm.doFinalize,
        arterialPressure: null,
        canEdit: true,
        clinicalExam: vm.clinicalExam,
        diagnostics: vm.diagnosticHypothesisAdd,
        duration: vm.consultationDuration,
        heartRate: null,
        height: vm.attendance.height,
        imc: vm.attendance.imc,
        interrogationAboutVariousDevices: null,
        mainComplaint: vm.mainComplaint,
        patientId: vm.attendance.patientId,
        patientName: vm.attendance.patientName,
        phisicalExamDescribed: null,
        progressiveHistoryPresentMolestation: null,
        respiratoryFrequency: null,
        someExams: vm.someExams,
        someMedicines: vm.someMedicines,
        weight: vm.attendance.weight
      };

      await vm.axios
        .put(
          vm.$store.state.filooServer +
            "medical-records/" +
            vm.$props.medicalRecordId +
            "/attendance",
          diagnosis,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
    },
    async saveConduct() {
      const vm = this;

      await vm.axios
      .put(
        vm.$store.state.filooServer +
          "medical-records/" +
          vm.$route.params.id +
          "/conduct",
        vm.conductDto,
        {
          headers: { Authorization: vm.$session.get("bearer") }
        }
      )
    },
    async updateConduct() {
      const vm = this;

      await vm.axios
      .put(
        vm.$store.state.filooServer +
          "medical-records/" +
          vm.$route.params.id +
          "/conductupdate",
        vm.conductDto,
        {
          headers: { Authorization: vm.$session.get("bearer") }
        }
      )
    },
    downloadMedicalRecords() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medical-records/" +
            vm.$route.params.id +
            "/download-token",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          let dataToken = response.data.token;
          window.open(
            vm.$store.state.filooServer +
              "/medical-records/" +
              vm.$props.medicalRecordId +
              "/complete/download/" +
              dataToken
          );
        });
    },
    getToken() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medical-records/" +
            vm.$route.params.id +
            "/download-token",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.token = response.data.token;
          }
        });
    },
    clickButtonPrint(type) {
      const vm = this;
      let url = "";
      switch (type) {
        case "common_medicine":
          url = "/medicine/download/";
          break;
        case "controlled_medicine":
          url = "/medicine-control/download/";
          break;
        case "exams_and_vaccines":
          url = "/exams-and-vaccines/download/";
          break;
        case "recommendations":
          url = "/general-attestations/download/";
          break;
        case "general_attestations":
          var types = [
            "common_medicine",
            "controlled_medicine",
            "exams-and-vaccines",
            "recommendations"
          ];
          for (let i = 0; i < 4; i++) {
            vm.clickButtonPrint(types[i]);
          }
          break;
        default:
          break;
      }
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medical-records/" +
            vm.$route.params.id +
            url +
            vm.token,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function() {
          window.open(
            vm.$store.state.filooServer +
              "medical-records/" +
              vm.$route.params.id +
              url +
              vm.token
          );
        });
    },
    calculateIMC() {
      const vm = this;
      if (vm.appointment.weight && vm.appointment.height) {
        let imc =
          vm.appointment.weight /
          (vm.appointment.height * vm.appointment.height);
        vm.appointment.imc = imc.toFixed(2);
      } else {
        vm.appointment.imc = null;
      }
    },
    selectNextStep(nextStep) {
      const vm = this;
      let dias = nextStep;
      let json = {};
      let description = "Retorno em " + dias + " dias";
      if (nextStep == 0) {
        json = {
          id: null,
          amountDay: null,
          amountDayUntilReturn: null,
          description: "Alta",
          type: "DISCHARGE"
        };
      } else if (nextStep < 31) {
        json = {
          id: "1",
          amountDay: dias,
          amountDayUntilReturn: null,
          description: description,
          type: "RETURN"
        };
      } else if (nextStep < 61) {
        json = {
          id: "2",
          amountDay: dias,
          amountDayUntilReturn: null,
          description: description,
          type: "RETURN"
        };
      } else {
        json = {
          id: "3",
          amountDay: dias,
          amountDayUntilReturn: null,
          description: description,
          type: "RETURN"
        };
      }
      vm.appointment.nextStep = json;
    },
    showPagePatientData() {
      const vm = this;
      vm.$emit("showPagePatientData", event);
    },
    getPatientHealthData() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medical-records/" +
            vm.$route.params.id +
            "/health-data",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.patientHealthData = response.data;
          }
        });
    },
    getConduct() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medical-records/" +
            vm.$route.params.id +
            "/conduct",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.conduct = response.data;
            vm.someMedicines = vm.conduct.someMedicines;
            vm.medicalRecommendations = vm.conduct.medicalRecommendations;
            vm.paid = vm.conduct.paid;
            if (vm.conduct.daysToReturn > 0) {
              vm.inputDayNextSteps = vm.conduct.daysToReturn;
              vm.patientReturn = true;
              vm.patientDischarge = false;
              if(vm.conduct.payStatus === "pago"){
                vm.paid = true
              } else if (vm.conduct.payStatus === "gratuito") {
                vm.paid = false
              } else {
                vm.paid = null
              }
            } else {
                vm.patientDischarge = true;
                vm.paid = null
            }

            if (vm.conduct.exams.length > 0) {
              vm.fillExams(vm.conduct.exams);
            }
            if (vm.conduct.drugControlledPsychotropic.length > 0) {
              vm.fillDrugControlledPsychotropic(
                vm.conduct.drugControlledPsychotropic
              );
            }
            if (vm.conduct.commonPrescriptionDrug.length > 0) {
              vm.fillCommonPrescriptionDrug(vm.conduct.commonPrescriptionDrug);
            }
            if (vm.conduct.drugControlledRevenue.length > 0) {
              vm.fillDrugControlledRevenue(vm.conduct.drugControlledRevenue);
            }
          }
        });
    },
    fillExams(exams) {
      const vm = this;
      let index = 0;
      for (index = 0; index < exams.length; index++) {
        vm.examsAdd[index] = exams[index];
        vm.exams[index] = exams[index];
      }
    },
    fillDrugControlledPsychotropic(drugControlledPsychotropic) {
      const vm = this;
      let index = 0;
      for (index = 0; index < drugControlledPsychotropic.length; index++) {
        vm.psychotropicControlledDrugsAdd[index] =
          drugControlledPsychotropic[index];
        vm.controlledDrugs[index] = drugControlledPsychotropic[index].drug;
      }
    },
    fillCommonPrescriptionDrug(commonPrescriptionDrug) {
      const vm = this;
      let index = 0;
      for (index = 0; index < commonPrescriptionDrug.length; index++) {
        vm.commonDrugAdd[index] = commonPrescriptionDrug[index];
        vm.commonDrugs[index] = commonPrescriptionDrug[index].drug;
      }
    },
    fillDrugControlledRevenue(drugControlledRevenue) {
      const vm = this;
      let index = 0;
      for (index = 0; index < drugControlledRevenue.length; index++) {
        vm.prescriptionDrugsAdd[index] = drugControlledRevenue[index];
        vm.prescriptionDrugs[index] = drugControlledRevenue[index].drug;
      }
    },
    getRegistrationData() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medical-records/" +
            vm.$route.params.id +
            "/registration-data",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.registrationData = response.data;
          }
        });
    },
    getAttendance() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medical-records/" +
            vm.$route.params.id +
            "/attendance",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.attendance = response.data;
            vm.someExams = vm.attendance.someExams;
            vm.mainComplaint = vm.attendance.mainComplaint;
            vm.consultationDuration = vm.attendance.duration;
            vm.clinicalExam = vm.attendance.clinicalExam;
            vm.fillDiagnostics(vm.attendance.diagnostics);
          }
        });
    },
    fillDiagnostics(diagnostics) {
      const vm = this;

      let index = 0;
      for (index = 0; index < diagnostics.length; index++) {
        vm.diagnosticHypothesisAdd[index] = diagnostics[index];
      }
      vm.diagnosticHypothesisAdd.push({});
      vm.diagnosticHypothesisAdd.splice(vm.diagnosticHypothesisAdd.length-1);
    },

    getDiagnosticHypothesis() {
      const vm = this;
      const page = vm.currentx - 1;
      vm.axios
        .get(vm.$store.state.filooServer + "diagnosis?page=" + page + "&size=10" + "&search=" + vm.newDiagnostic, {
          headers: {
            Authorization: vm.$session.get("bearer")
          }
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.diagnosticHypothesis = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.diagnosticHypothesis.push({});
            vm.diagnosticHypothesis.splice(vm.diagnosticHypothesis.length-1);
          }
        });
    },
    getFirstDiagnosticHypothesis() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "diagnosis", {
          headers: {
            Authorization: vm.$session.get("bearer")
          }
        })
        .then(function (response) {
          if (response.status === 200) {
              vm.firstOptions = response.data.content;
            }
          });
    },
    getPrescriptionDrugs(word) {
      const vm = this;
      vm.charsPrescriptionDrugs.push(word.data);
      let concatWord = vm.charsPrescriptionDrugs.join("");
      if (vm.charsPrescriptionDrugs.length >= 3) {
        vm.axios
          .get(vm.$store.state.filooServer + "medicines?search=" + concatWord, {
            headers: { Authorization: vm.$session.get("bearer") }
          })
          .then(function(response) {
            if (response.status === 200) {
              vm.prescriptionDrugs = response.data;
              while (vm.charsPrescriptionDrugs.length > 0) {
                vm.charsPrescriptionDrugs.pop();
                concatWord = "";
              }
            }
          });
      }
    },
    getMedicalRecordStatus() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "medical-records/status", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.status = response.data;
          }
        });
    },
    addExam() {
      const vm = this;
      vm.examsAdd.push([]);
    },
    removeExam(index) {
      const vm = this;
      vm.examsAdd.splice(index, 1);
    },
    addCommonDrug() {
      const vm = this;
      vm.commonDrugAdd.push({});
    },
    removeCommonDrug(index) {
      const vm = this;
      vm.commonDrugAdd.splice(index, 1);
    },
    addControlledDrugs() {
      const vm = this;
      vm.psychotropicControlledDrugsAdd.push({});
    },
    removeControlledDrugs(index) {
      const vm = this;
      vm.psychotropicControlledDrugsAdd.splice(index, 1);
    },
    addPrescriptionDrugs() {
      const vm = this;
      vm.prescriptionDrugsAdd.push({});
    },
    removePrescriptionDrugs(index) {
      const vm = this;
      vm.prescriptionDrugsAdd.splice(index, 1);
    },
    addDiagnosticHypothesis() {
      const vm = this;
      vm.diagnosticHypothesisAdd.push([]);
    },
    removeDiagnosticHypothesis(index) {
      const vm = this;
      vm.diagnosticHypothesisAdd.splice(index, 1);
    },
    getExams() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "exams", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.exams = response.data;
          }
        });
    },
    isEmpty(obj) {
      if (obj == null) return true;
      if (obj.length > 0) return false;
      if (obj.length === 0) return true;
      for (let key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
      }
      return true;
    },
    nextPageCommon(){
      const vm = this;
      if(vm.pageCommon < vm.totalPagesCommon) {
        vm.pageCommon++;
        vm.getMedicinesCommon();
      }
    },
    lastPageCommon(){
      const vm = this;
      if(vm.pageCommon > 0) {
        vm.pageCommon--;
        vm.getMedicinesCommon();
      }
    },
    nextPagePrescription(){
      const vm = this;
      if(vm.pagePrescription < vm.totalPagesPrescription) {
        vm.pagePrescription++;
        vm.getMedicinesPrescription();
      }
    },
    lastPagePrescription(){
      const vm = this;
      if(vm.pagePrescription > 0) {
        vm.pagePrescription--;
        vm.getMedicinesPrescription();
      }
    },
    nextPageControlled(){
      const vm = this;
      if(vm.pagePrescription < vm.totalPagesPrescription) {
        vm.pageControlled++;
        vm.getMedicinesControlled();
      }
    },
    lastPageControlled(){
      const vm = this;
      if(vm.pageControlled > 0) {
        vm.pageControlled--;
        vm.getMedicinesControlled();
      }
    },
    findCommon(search) {
      const vm = this;
      vm.pageCommon = 0;
      vm.searchCommon = search
      vm.getMedicinesCommon()
    },
    findPrescription(search) {
      const vm = this;
      vm.pagePrescription = 0;
      vm.searchPrescription = search
      vm.getMedicinesPrescription()
    },
    findControlled(search) {
      const vm = this;
      vm.pageControlled = 0;
      vm.searchControlled = search
      vm.getMedicinesControlled()
    },
    getMedicinesCommon() {
      const vm = this;
      vm.commonDrugsIsLoading = true;
        vm.axios
          .get(vm.$store.state.filooServer + "medicines?page=" + vm.pageCommon + "&search="+ vm.searchCommon + "&size=10&sort=product,asc", {
            headers: { Authorization: vm.$session.get("bearer") }
          })
          .then(function(response) {
            if (response.status === 200) {
              vm.commonDrugs = response.data.content;
              vm.totalPagesCommon = response.data.totalPages - 1;
            }
          })
          .finally(function() {
            vm.commonDrugsIsLoading = false;
          });
    },
    getMedicinesPrescription() {
      const vm = this;
      vm.prescriptionDrugsIsLoading = true;
        vm.axios
          .get(vm.$store.state.filooServer + "medicines?page=" + vm.pagePrescription + "&search="+ vm.searchPrescription + "&size=10&sort=product,asc", {
            headers: { Authorization: vm.$session.get("bearer") }
          })
          .then(function(response) {
            if (response.status === 200) {
              vm.prescriptionDrugs = response.data.content;
              vm.totalPagesPrescription = response.data.totalPages - 1;
            }
          })
          .finally(function() {
            vm.prescriptionDrugsIsLoading = false;
          });
    },
    getMedicinesControlled() {
      const vm = this;
      vm.controlledDrugsIsLoading = true;
        vm.axios
          .get(vm.$store.state.filooServer + "medicines?page=" + vm.pageControlled + "&search="+ vm.searchControlled + "&size=10&sort=product,asc", {
            headers: { Authorization: vm.$session.get("bearer") }
          })
          .then(function(response) {
            if (response.status === 200) {
              vm.controlledDrugs = response.data.content;
              vm.totalPagesControlled = response.data.totalPages - 1;
            }
          })
          .finally(function() {
            vm.controlledDrugsIsLoading = false;
          });
    },
    commonLabel({ product, presentation }){
      return `${product} – ${presentation}`
    },
    examNotEmpty() {
      const vm = this;
      return !vm.testNullUndefinedEmpty(vm.examsAdd[0].id);
    },
    recomendationNotEmpty() {
      const vm = this;
      return !vm.testNullUndefinedEmpty(vm.medicalRecommendations);
    },
    commonDrugAddNotEmpty() {
      const vm = this;
      return !vm.testNullUndefinedEmpty(vm.commonDrugAdd)  && !vm.testNullUndefinedEmpty(vm.commonDrugAdd[0].drug);
    },
    prescriptionDrugsAddNotEmpty() {
      const vm = this;
      return !vm.testNullUndefinedEmpty(vm.prescriptionDrugsAdd)  && !vm.testNullUndefinedEmpty(vm.prescriptionDrugsAdd[0].drug);
    },
    psychotropicControlledDrugsAddNotEmpty() {
      const vm = this;
      return !vm.testNullUndefinedEmpty(vm.psychotropicControlledDrugsAdd)  && !vm.testNullUndefinedEmpty(vm.psychotropicControlledDrugsAdd[0].drug);
    },
    addNewDiagnosticHypothesis(index) {
      const vm = this;
      vm.diagnosticHypothesisAdd.push(vm.diagnosticHypothesis[index]);
    },
    changePagination(){
      const vm = this;
      vm.getDiagnosticHypothesis();
    },
    changeSearch(){
      const vm = this;
      vm.currentx = 0;
      vm.getDiagnosticHypothesis();
    },
  }
};
</script>
<style lang="scss" src="./PatientAttendance.scss">
</style>
